import { render, staticRenderFns } from "./OrderRedeem.vue?vue&type=template&id=1037a548&scoped=true"
import script from "./OrderRedeem.vue?vue&type=script&lang=js"
export * from "./OrderRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037a548",
  null
  
)

export default component.exports